import React from 'react'
import './404.css'

export default () => (
  <div className='error__wrapper'>
    <h1>404</h1>
    <h2>Page Not Found</h2>
    <p>Looks like the page you are looking for is missing :(</p>
  </div>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/404.js